<template>
<div class="loadingio-spinner-ripple-na2jmvgicts centerThing">
    <div class="ldio-42m7jdd8mey">
        <div>
        </div>
        <div>
        </div>
    </div>
</div>
</template>
<script>
export default{
    name:"loading"
}
</script>
<style type="text/css">
@keyframes ldio-42m7jdd8mey {
  0% {
    top: 96px;
    left: 96px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 18px;
    left: 18px;
    width: 156px;
    height: 156px;
    opacity: 0;
  }
}.ldio-42m7jdd8mey div {
  position: absolute;
  border-width: 4px;
  border-style: solid;
  opacity: 1;
  border-radius: 50%;
  animation: ldio-42m7jdd8mey 1s cubic-bezier(0,0.2,0.8,1) infinite;
}.ldio-42m7jdd8mey div:nth-child(1) {
  border-color: #b4243a;
  animation-delay: 0s;
}
.ldio-42m7jdd8mey div:nth-child(2) {
  border-color: #b4243a;
  animation-delay: -0.5s;
}
.loadingio-spinner-ripple-na2jmvgicts {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: rgba(255, 255, 255, 0);
}
.ldio-42m7jdd8mey {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-42m7jdd8mey div { box-sizing: content-box; }

.centerThing{
  margin-left: 30%;
}
</style>